/* BROKENWING storefront helpers: wishlist toggle + mobile gender filter. */
(function () {
  'use strict';

  // Default gender filter state on the body so .bw-f-* rules apply.
  if (!/\bbw-f-(all|men|women)\b/.test(document.body.className)) {
    document.body.classList.add('bw-f-all');
  }

  document.addEventListener('click', function (e) {
    // Account-bound wishlist heart.
    //  - logged out  -> redirect to login, returning to the current page
    //  - demo card    -> cosmetic toggle (no product to save)
    //  - logged in    -> POST to the app-proxy worker to add/remove
    var wish = e.target.closest('[data-bw-wish]');
    if (wish) {
      e.preventDefault();
      var BW = window.BW || {};

      if (!BW.customer) {
        var ret = encodeURIComponent(window.location.pathname + window.location.search);
        var login = BW.loginUrl || '/account/login';
        window.location.href = login + (login.indexOf('?') === -1 ? '?' : '&') + 'return_url=' + ret;
        return;
      }

      var pid = wish.getAttribute('data-bw-product-id');
      if (!pid) {
        // Demo card: cosmetic only.
        wish.setAttribute('aria-pressed', wish.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        return;
      }

      if (wish.hasAttribute('data-bw-busy')) return;
      var wasOn = wish.getAttribute('aria-pressed') === 'true';
      wish.setAttribute('data-bw-busy', '');
      wish.setAttribute('aria-pressed', wasOn ? 'false' : 'true'); // optimistic

      fetch('/apps/wishlist/toggle', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productId: pid })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (data) {
          wish.removeAttribute('data-bw-busy');
          var added = !!data.added;
          wish.setAttribute('aria-pressed', added ? 'true' : 'false');
          wish.setAttribute('aria-label', added ? 'Remove from wishlist' : 'Add to wishlist');
          updateWishlistCount(data.count);
          // On the wishlist page, removing a product drops its card.
          if (!added && document.querySelector('[data-bw-wishlist-page]')) {
            removeWishlistCard(wish);
          }
        })
        .catch(function () {
          // Revert optimistic state on failure.
          wish.removeAttribute('data-bw-busy');
          wish.setAttribute('aria-pressed', wasOn ? 'true' : 'false');
        });
      return;
    }

    // Mobile gender tabs.
    var tab = e.target.closest('[data-bw-gender]');
    if (tab) {
      var g = tab.getAttribute('data-bw-gender');
      document.body.classList.remove('bw-f-all', 'bw-f-men', 'bw-f-women');
      document.body.classList.add('bw-f-' + g);
      var group = tab.closest('[data-bw-gtabs]');
      if (group) {
        group.querySelectorAll('[data-bw-gender]').forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
        });
      }
    }
  });

  function updateWishlistCount(count) {
    if (typeof count !== 'number') return;
    var el = document.querySelector('.bw-wishlist__count');
    if (el) el.textContent = count;
  }

  function removeWishlistCard(wish) {
    var card = wish.closest('.bw-card');
    if (!card) return;
    card.setAttribute('data-bw-removing', '');
    setTimeout(function () {
      card.remove();
      // If the grid is now empty, reload so the section renders its empty state.
      var grid = document.querySelector('[data-bw-wishlist-grid]');
      if (grid && !grid.querySelector('.bw-card')) window.location.reload();
    }, 260);
  }
})();
